/** A tuning document that breaks the knob table's rules (a values file, a save, or a live site's published tuning). */
export class TuningError extends Error {
  override readonly name = 'TuningError'
}
